import { useTranslate } from "@tolgee/react";
import React, { Suspense } from "react";
import { usePageInit } from "src/common/hooks";
import { Loading } from "src/components";

const InvalidKey = React.lazy(() => import("./InvalidKey"));

function InvalidKeyPage(props) {
  const { t } = useTranslate();
  usePageInit(
    t({
      key: "pages.invalidKeyPage.title",
      defaultValue: "Smart Portal - Invalid Key",
    }),
  );
  return (
    <Suspense
      fallback={
        <Loading
          addContainer
          active
          loadingText={t({ key: "common.loading", defaultValue: "Loading" })}
        />
      }
    >
      <InvalidKey {...props} />
    </Suspense>
  );
}

export default InvalidKeyPage;
